import styled from "styled-components";

export const ContentWrapperStyled = styled.section`
  padding: 150px 128px;

`;
